import React, { useEffect, useState } from 'react';
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';
import TableRenderers from 'react-pivottable/TableRenderers';
import Plot from 'react-plotly.js';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import { useDispatch, useSelector } from 'react-redux';
import { getActs, successLoadActs } from '../../../../redux/reducers/act-reducer';
import { getActTemplate, getActTemplateProject } from '../../../../redux/reducers/act-template-reducer';
import { MasterOfActsAPI } from '../../../../api/api';


const PlotlyRenderers = createPlotlyRenderers(Plot);
const PivotTableComponent = ({projects,selectedActs}) => {
  let acts = useSelector(getActs).acts
  let environments = []
  acts.forEach(i=>environments.push(i["environment_state"]))
  environments = [...new Set(environments)]
  let environmentState = []
  let template = []
  const getEnvironmentState = async (i)=> {
    try {
          environmentState = await MasterOfActsAPI.getEnvironmentState(i);
          template = await MasterOfActsAPI.getFieldTemplates(environmentState?.data.act_template);
          acts.map(el=>{if (el.environment_state==i){el.fields=template?.data}})
          acts.map(el=>{el.fields.forEach(e=>{e.value = el.raw_content[e.variable]})
          })
        }catch (error) {
          console.error('Error:', error);
        }
    }
  useEffect(() => {
    (async () => {
       for (const i of environments) 
    {
    getEnvironmentState(i)
    }
    })()
 
  }, []);
  
  let actsPivot = []
  let actPivot = {}

try
{acts.map(act=>{
  act?.fields.map(el=>{
    if (el?.type!="qr-code-field" && el?.type!="selected-offense-list" && el?.type!="table_constructor" && el?.type!="signature-field")
    { if(typeof el?.value == "object"){
      (el?.value?.value)?actPivot[el?.variable] = el?.value?.value:actPivot[el?.variable] = ""}
else {
       (el?.value)?actPivot[el?.variable] = el?.value:actPivot[el?.variable] = ""}}})
  actsPivot.push(actPivot)
  actPivot = {}
  
})}
catch (error) {
          console.error('Error:', error);
        }

// 1. ниже всё, что состоит из цифры превращается в цифры
actsPivot = actsPivot.map(obj => {
  const newObj = {};
  for (const key in obj) {
    const num = parseFloat(obj[key]);
    newObj[key] = isNaN(num) ? obj[key] : num;
  }
  return newObj;
});

const allKeys = [...new Set(actsPivot.flatMap(Object.keys))];



// ниже функциия для поиска и исключения не применяемых ключей в каждом проекте
function filterAlwaysEmptyKeys(objects, emptyValues = [0, null, undefined, '']) {
  // First pass: identify keys that are always empty
  const keyStatus = {};
  
  objects.forEach(obj => {
    Object.keys(obj).forEach(key => {
      if (!keyStatus.hasOwnProperty(key)) {
        keyStatus[key] = false; // Assume empty until proven otherwise
      }
      if (!emptyValues.includes(obj[key])) {
        keyStatus[key] = true; // Key has at least one non-empty value
      }
    });
  });

  // Get keys that are never populated
  const keysToRemove = Object.keys(keyStatus).filter(key => !keyStatus[key]);

  // Second pass: remove those keys from all objects
  return objects.map(obj => {
    const newObj = { ...obj };
    keysToRemove.forEach(key => delete newObj[key]);
    return newObj;
  });
}
actsPivot = filterAlwaysEmptyKeys(actsPivot)

function getAlwaysNumericKeys(objects) {
  // Handle null/undefined input
  if (!objects) return [];
  
  // Ensure we're working with an array
  const arr = Array.isArray(objects) ? objects : [objects];
  
  if (arr.length === 0) return [];
  
  // Safely get keys from each object
  const allKeys = [...new Set(arr.flatMap(obj => {
    if (!obj || typeof obj !== 'object') return [];
    return Object.keys(obj).filter(k => obj.hasOwnProperty(k));
  }))];
  
  return allKeys.filter(key => 
    arr.every(obj => {
      if (!obj || !obj.hasOwnProperty(key)) return false;
      const value = obj[key];
      return typeof value === 'number' && !isNaN(value) ||
             (typeof value === 'string' && !isNaN(value) && value.trim() !== '');
    })
  );
}



  const [state, setState] = React.useState({
    data: actsPivot,
        rows: allKeys,
        cols: [],
        aggregatorName: 'Sum',
        vals: getAlwaysNumericKeys(actPivot),
        rendererName: 'Table',
  });
if (actPivot.length<1){
  return <div></div>
}
else{

  return (
    <div>
      <PivotTableUI
        data={state.acts}
        onChange={s => setState(s)}
        renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
        {...state}
      />
    </div>
  );

}

};

export default PivotTableComponent;